import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import {
  getAuth,
  signOut as firebaseSignOut,
  OAuthProvider,
} from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyD4Q-gLN4nb4aowT0kxIE0JTTZhCD4vNnk",
  authDomain: "socrates-776ca.firebaseapp.com",
  projectId: "socrates-776ca",
  storageBucket: "socrates-776ca.appspot.com",
  messagingSenderId: "558993052601",
  appId: "1:558993052601:web:6862d6e374498610361c68",
  measurementId: "G-T25W3KBEY9",
};

// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig);

// Get Firebase services
const auth = getAuth(firebaseApp);
const db = getFirestore(firebaseApp);
const storage = getStorage(firebaseApp);
// Specify the region for functions
const functions = getFunctions(firebaseApp, "northamerica-northeast1");

// Create Microsoft OAuth provider
const microsoftProvider = new OAuthProvider("microsoft.com");

// Export Firebase services and configuration
export { firebaseConfig, auth, db, storage, functions, microsoftProvider };

// Export the signOut function
export const signOut = () => firebaseSignOut(auth);

export default firebaseApp;
